// extracted by mini-css-extract-plugin
module.exports = {"sectionWrap":"_3rqg8","sectionTitle":"SmJX9","cardsWrapper":"l5Uac"};